import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Slider, Handles, Rail, Ticks } from 'react-compound-slider';

import * as sliderStyles from './sliderStyles';
import styles from './style.scss';


const SliderButton = ({
  handle: { id, percent },
  getHandleProps,
  isDisabled,
}) => (
  <div className={classNames(styles.sliderButton, isDisabled && styles.sliderButtonDisabled)}
    style={sliderStyles.sliderButtonStyle({ percent })}
    {...getHandleProps(id)} />
);

const SliderTickElements = ({ tick, isDisabled }) => {
  return (
    <div style={sliderStyles.sliderTickElementsStyle({ tick, isDisabled })} />
  );
};

export function SliderRail({ getRailProps, isDisabled }) {
  return (
    <React.Fragment>
      <div style={sliderStyles.railOuterStyle({ isDisabled })} {...getRailProps()} />
      <div style={sliderStyles.railStyle({ isDisabled })} />
    </React.Fragment>
  );
}

SliderRail.propTypes = {
  getRailProps: PropTypes.func.isRequired,
};

class PreferencesSlider extends React.Component {
  constructor(props) {
    super(props);
  }

  mobileRangeText() {
    const { minTickText, maxTickText, isDisabled } = this.props;
    return (
      <div className={styles.mobileRangeText}>
        <div className={classNames(styles.minTickTextMobile, { isDisabled })}>
          <span>
            {minTickText}
          </span>
        </div>
        <div className={classNames(styles.maxTickTextMobile, { isDisabled })}>
          <span>
            {maxTickText}
          </span>
        </div>
      </div>
    );
  }

  handleChange(val) {
    const { name, handleChange } = this.props;
    if (handleChange) {
      const value = val[0];
      this.props.handleChange({ name, value });
    }
  }

  render() {
    const {
      min, max, step, defaultValue,
      extraClassName, minTickText, maxTickText,
      isDisabled,
    } = this.props;

    return (
      <div className={classNames(styles.slider, extraClassName)}>
        {minTickText && (
          <div className={classNames(styles.minTickText, { isDisabled })}>
            <span>
              {minTickText}
            </span>
          </div>
        )}
        {this.mobileRangeText()}
        <Slider
          rootStyle={sliderStyles.main}
          domain={[min, max]}
          step={step}
          mode={2}
          values={[defaultValue]}
          disabled={isDisabled}
          onSlideEnd={(val) => { this.handleChange(val); }}>
          <Rail>
            {({ getRailProps }) => (
              <SliderRail getRailProps={getRailProps} isDisabled={isDisabled} />
            )}
          </Rail>
          {/* чтобы отключить изменение по клику <div style={railStyle} /> */}
          <Handles>
            {({ handles, getHandleProps }) => (
              <div className="slider-handles">
                {handles.map((handle) => (
                  <SliderButton
                    isDisabled={isDisabled}
                    key={handle.id}
                    handle={handle}
                    getHandleProps={getHandleProps} />
                ))}
              </div>
            )}
          </Handles>
          {(minTickText && maxTickText) && (
            <Ticks values={[min, max]}>
              {({ ticks }) => (
                <div className="slider-ticks">
                  {ticks.map((tick) => (
                    <SliderTickElements isDisabled={isDisabled} key={tick.id} tick={tick} count={ticks.length} />
                  ))}
                </div>
              )}
            </Ticks>
          )}
        </Slider>
        {maxTickText && (
          <div className={classNames(styles.maxTickText, { isDisabled: isDisabled })}>
            <span>
              {maxTickText}
            </span>
          </div>
        )}
      </div>
    );
  }
};

PreferencesSlider.propTypes = {
  name: PropTypes.string.isRequired,
  handleChange: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  defaultValue: PropTypes.number,
  extraClassName: PropTypes.string,
  isDisabled: PropTypes.bool,
};

PreferencesSlider.defautlProps = {
  min: 0,
  max: 100,
  step: 1,
  defaultValue: 50,
  minTickText: '',
  maxTickText: '',
  extraClassName: '',
  isDisabled: false,
};

export default PreferencesSlider;
